import useInternationalization from '../../hooks/useInternationalization';
import dcwLogo from '../../assets/images/dcw.svg';
import styles from './styles.module.css';

const DEVOTIONAL_URL = 'https://deafchurchwhere.com/resources/';

interface Props {
  darkMode: boolean;
  iconOnly?: boolean;
}

/**
 * Open Deaf Church Where devotionals in a new tab.
 */
const openDevotional = (): void => {
  window.open(DEVOTIONAL_URL, '_blank', 'noopener,noreferrer');
};

/**
 * Devotional link (Deaf Church Where) for the watch plan page.
 */
const WatchPlanResources = ({ darkMode, iconOnly = false }: Props): JSX.Element => {
  const { getIntlText } = useInternationalization();
  const label = getIntlText('devotional');

  return (
    <button
      type="button"
      className={`${styles.resourcesItem} ${darkMode && styles.resourcesItemDarkMode} ${
        iconOnly && styles.resourcesItemIconOnly
      }`}
      onClick={openDevotional}
      aria-label={label}
      title={label}
    >
      <img src={dcwLogo} alt="" className={styles.devotionalLogo} crossOrigin="anonymous" />
      {!iconOnly && <span>{label}</span>}
    </button>
  );
};

export default WatchPlanResources;
